import apiClient from './apiClient';

export const getMediaUrl = (relativeUrl) =>
  apiClient.defaults.baseURL.replace(/\/api$/, '') + relativeUrl;

export const listProceduraFiles  = (procId) => apiClient.get(`/proceduri/${procId}/files/`).then(r => r.data);
export const deleteProceduraFile = (fileId) => apiClient.delete(`/proceduri-files/${fileId}/`).then(r => r.data);

export const uploadProceduraFile = (procId, denumire, file) => {
  const fd = new FormData();
  fd.append('denumire', denumire);
  fd.append('file', file);
  return apiClient.post(`/proceduri/${procId}/files/`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};
